var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99219 23.9995V29.9995C3.99219 39.9995 7.99219 43.9995 17.9922 43.9995H29.9922C39.9922 43.9995 43.9922 39.9995 43.9922 29.9995V17.9995C43.9922 11.7595 42.4321 7.8395 38.8121 5.7995C37.7921 5.2195 35.7522 4.77949 33.8922 4.47949",
    stroke: "#219EBC",
    strokeWidth: 2.77886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9922 26H35.9922",
    stroke: "#219EBC",
    strokeWidth: 2.77886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34H36",
    stroke: "#219EBC",
    strokeWidth: 2.77886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 10.748H19.201",
    stroke: "#219EBC",
    strokeWidth: 2.41242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0054 9.36606V13.8639C14.0054 16.5982 12.79 17.6919 9.75155 17.6919H6.1054C3.06695 17.6919 1.85156 16.5982 1.85156 13.8639V9.36606C1.85156 6.63179 3.06695 5.53809 6.1054 5.53809H9.75155C12.79 5.53809 14.0054 6.63179 14.0054 9.36606Z",
    stroke: "#219EBC",
    strokeWidth: 2.41242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.357 9.36606V13.8639C31.357 16.5982 30.1416 17.6919 27.1031 17.6919H23.457C20.4185 17.6919 19.2031 16.5982 19.2031 13.8639V9.36606C19.2031 6.63179 20.4185 5.53809 23.457 5.53809H27.1031C30.1416 5.53809 31.357 6.63179 31.357 9.36606Z",
    stroke: "#219EBC",
    strokeWidth: 2.41242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass3);
export default __webpack_public_path__ + "static/media/glass3.2ee59920d0a34afd10288d6616da7e77.svg";
export { ForwardRef as ReactComponent };